import { formatISO, isDate } from 'date-fns';
import { hasToString } from '../../functions/has-to-string/has-to-string.function';

/**
 * When the second parameter of the {@see TtSelectionModel.predicate} isn't set
 * it will use this function a default predicate.
 *
 * This function will work with most of our classes by either checking for the {@see JsonLd.getIri}
 * method or checking if the object have an id property.
 */
export function defaultPredicate(element: object | string | number | Date): string | number {
  if (typeof element === 'string' || typeof element === 'number') {
    return element;
  }
  if (typeof element === 'object' && 'getIri' in element && typeof element.getIri === 'function') {
    return element.getIri() as string;
  }
  if (typeof element === 'object' && 'id' in element) {
    return element['id'] as string | number;
  }

  if (typeof element === 'object' && '@id' in element) {
    return element['@id'] as string;
  }

  if (isDate(element)) {
    return formatISO(element);
  }

  if (hasToString(element)) {
    return element.toString();
  }

  throw Error('add a string or predicate function to determine the unique id of the elements');
}
